import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { selectors as OrganizationSelectors } from 'data/organizations'

import { dataFetched as dataFetchedAction, makesQueries } from 'data/graphql'
import {
  viewIsLoading,
  viewHasLoaded,
  viewFailedToLoad,
  injectViewStateAsMeta,
} from 'data/ui/viewState'

import {
  organizationAttrsFragment,
  organizationResourcesUsageFragment,
} from 'remote/organizations'
import { userAttrsFragment } from 'remote/users'

const organizationQuery = gql`
  query currentOrganization($organizationId: ID!) {
    showOrganization(id: $organizationId) {
      owner {
        ...userAttrs
      }
      ...organizationAttrs
      ...organizationResourcesUsage
    }
  }

  ${userAttrsFragment}
  ${organizationAttrsFragment}
  ${organizationResourcesUsageFragment}
`

export const syncsOrganization = viewName =>
  compose(
    connect(
      state => ({
        organizationId: OrganizationSelectors.getOrganizationId(state),
      }),
      {
        dataFetched: dataFetchedAction,
        viewIsLoading,
        viewFailedToLoad,
        injectViewStateAsMeta,
      }
    ),
    makesQueries({
      query: organizationQuery,
      mapPropsToVariables: ({ organizationId }) => ({
        organizationId,
        pagination: {
          first: 50,
        },
      }),
      getOnQueryFromProps: ({ viewIsLoading }) => () =>
        viewIsLoading(viewName, 'loadOrganization'),
      getOnResultFromProps: ({ injectViewStateAsMeta, dataFetched }) => ({
        result,
        meta,
      }) => {
        const organization = result.data.showOrganization

        injectViewStateAsMeta(
          dataFetched(organization, meta),
          viewHasLoaded(viewName, 'loadOrganization')
        )
      },
      getOnErrorFromProps: ({ viewFailedToLoad }) => ({ error }) =>
        viewFailedToLoad(viewName, 'loadOrganization', error),
    })
  )

export default syncsOrganization
